import { render, staticRenderFns } from "./chuxing.vue?vue&type=template&id=96d822d6&scoped=true&"
import script from "./chuxing.vue?vue&type=script&lang=js&"
export * from "./chuxing.vue?vue&type=script&lang=js&"
import style0 from "./chuxing.vue?vue&type=style&index=0&id=96d822d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d822d6",
  null
  
)

export default component.exports